module.exports = __webpack_public_path__ + "e-learning-app/static/img/school6.2908c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-course/img/ne/school6.png
// module id = GsSX
// module chunks = 1